import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';
import CurriculumManager from 'a/cutItOut/content/CurriculumManager';

export const initialState = {
  targetSoundId: null,
  wordPartId: null,
  pulsingPill: {
    label: null,
    duration: 0,
    interval: 0,
    isPulsing: false,
  },
  practicePictures: [],
  revealedPictures: [],
  activePictureLabel: null,
  highlightedPictureLabel: null,
  interactionLocked: false,
};

const practiceReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_ACTIVITY_WINDOW:
      return initialState;
    case REDUX_ACTIONS.INIT_PRACTICE: {
      const setNumber = 1 + action.payload.setNumber % CurriculumManager.getPracticeSetsAmount(
        action.payload.level,
      );
      return {
        ...initialState,
        targetSoundId: CurriculumManager.getPracticeTargetSoundId(
          action.payload.level,
          setNumber,
        ),
        practicePictures: CurriculumManager.getPracticePictures(
          action.payload.level,
          setNumber,
        ),
        wordPartId: CurriculumManager.getPracticeWordPartId(
          action.payload.level,
          setNumber,
        ),
      };
    }
    case REDUX_ACTIONS.REVEAL_PICTURE: {
      const pictures = state.revealedPictures.slice();
      return {
        ...state,
        revealedPictures: [...pictures, action.payload.picture],
      };
    }
    case REDUX_ACTIONS.SET_PULSING_PILL:
      return {
        ...state,
        pulsingPill: {
          label: action.payload.label,
          duration: action.payload.duration,
          interval: action.payload.interval,
          isPulsing: true,
        },
      };
    case REDUX_ACTIONS.SET_PULSE_FINISHED:
      return {
        ...state,
        pulsingPill: initialState.pulsingPill,
      };
    case REDUX_ACTIONS.SET_ACTIVE_PICTURE:
      return {
        ...state,
        activePictureLabel: action.payload.activePictureLabel,
      };
    case REDUX_ACTIONS.SET_HIGHLIGHTED_PICTURE:
      return {
        ...state,
        highlightedPictureLabel: action.payload.highlightedPictureLabel,
      };
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    default:
      return state;
  }
};

export default practiceReducer;
